var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlarmProfileGray = function SvgAlarmProfileGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.428 13.54c.947-.111 1.86-.334 2.727-.654A4.48 4.48 0 0 1 17 9.875V9.5a3 3 0 1 0-6 0v.375a4.48 4.48 0 0 1-1.155 3.01c.866.32 1.78.543 2.727.656m2.857 0a12 12 0 0 1-2.857 0m2.857 0q.07.218.071.459a1.5 1.5 0 1 1-2.928-.46"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    x: 7,
    y: 2,
    stroke: "#697477",
    strokeWidth: 1.5,
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeWidth: 1.5,
    d: "m17.5 19.999-8.438 2.356A1.5 1.5 0 0 1 7.21 21.3L3.307 6.733a1.5 1.5 0 0 1 .967-1.808L7 3.999"
  })));
};
export { SvgAlarmProfileGray as ReactComponent };
export default __webpack_public_path__ + "4e01c2bd8f7bbbfed1ed40e01af226de.svg";